import { Injectable } from '@nestjs/common';
import { Uoms } from '../uom.entity';
import { UomsDTO } from './uom.dto';

@Injectable()
export class UomsAdapter {
  /**
   * 
   * @param uomsDTO 
   * 
   * @param isUpdate 
   */
  convertDtoToEntity(uomsDTO: UomsDTO,  isUpdate: boolean = false ): Uoms {
    try {
        const uom = new Uoms();
        uom.createdUser = uomsDTO.createdUser;
        uom.uomName = uomsDTO.uomName;
        uom.uomType = uomsDTO.uomType;
        console.log(uomsDTO);
        if(uomsDTO.uomId) {
            uom.uomId = uomsDTO.uomId;
            uom.updatedUser = uomsDTO.updatedUser;
        }
        uom.isActive = uomsDTO.isActive;
        return uom;
    } catch (Error) {
        throw Error;
    }
}
  
  public convertEntityToDto(uomsObject: Uoms): UomsDTO {
    const uomsDTO= new UomsDTO;
    uomsDTO.uomId = uomsObject.uomId;
    uomsDTO.uomName = uomsObject.uomName;
    uomsDTO.uomType = uomsObject.uomType;
    uomsDTO.isActive = uomsObject.isActive;
    uomsDTO.createdAt = uomsObject.createdAt;
    uomsDTO.updatedAt = uomsObject.updatedAt;
    uomsDTO.createdUser = uomsObject.createdUser;
    uomsDTO.updatedUser = uomsObject.updatedUser;
    uomsDTO.versionFlag = uomsObject.versionFlag;
    return uomsDTO;
  }
}
